"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

exports.default = shallowEqual;


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/react-stripe-elements/es/utils/shallowEqual.js
// module id = 1473
// module chunks = 4 5 10 13